module.exports = __webpack_public_path__ + "static/media/logo.e8c65ca9.png";